import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BooksetList from './BooksetList';
import styles from './style.scss';


const DashboardBooksetList = (props) => (
  <div className={classNames(styles.container, 'billetContainerNoOverflow')}>
    <BooksetList {...props} />
  </div>
);

DashboardBooksetList.propTypes = {
  booksets: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
};

export default DashboardBooksetList;
